module.exports = __webpack_public_path__ + "static/media/pa.3b7689aa.svg";